import { LessonProgress } from './LessonProgress.ts';

export interface CommitmentData {
  text: string;
  madeAt: string;
  unlocksAt: string;
  fulfilled: boolean | null;
}

export class CourseProgress {
  lessons: { [id: number]: LessonProgress } = {};
  commitments: { [lessonId: number]: CommitmentData } = {};

  finishedLesson(id: number) {
    const lessonProgress = new LessonProgress();
    lessonProgress.completed = true;
    this.lessons[id] = lessonProgress;
  }

  addCommitment(lessonId: number, text: string, unlockAfterHours: number) {
    const now = new Date();
    const unlocksAt = new Date(now.getTime() + unlockAfterHours * 60 * 60 * 1000);
    this.commitments[lessonId] = {
      text,
      madeAt: now.toISOString(),
      unlocksAt: unlocksAt.toISOString(),
      fulfilled: null,
    };
  }

  fulfillCommitment(lessonId: number, fulfilled: boolean) {
    if (this.commitments[lessonId]) {
      this.commitments[lessonId].fulfilled = fulfilled;
    }
  }

  toPlain(): object {
    const plainLessons: { [id: number]: object } = {};
    for (const [id, lesson] of Object.entries(this.lessons)) {
      plainLessons[Number(id)] = typeof lesson.toPlain === 'function' ? lesson.toPlain() : lesson;
    }
    return {
      lessons: plainLessons,
      commitments: this.commitments,
    };
  }
}
